import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from '../../services/auth.service';
import { KycService } from '../../services/kyc.service';
import Swal from 'sweetalert2';
import { KycService as ModalKycSrv } from '../../services/modal-kyc/kyc.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DetailRealEstateComponent } from '../detail-real-estate/detail-real-estate.component';
import { externalInvestForms } from '../../../environments/environment';
import { ProjectStatus } from '../../shared/models/project-status.enum';

declare var $: any;

export interface EncryptedData {
  userEmail: string;
  projectName: string;
  tokenQuantity: number;
  tokenAddress: string;
  sellerAddress: string;
  uid: string;
  wallet: string;
}

@Component({
  selector: 'app-card-real-estate',
  templateUrl: './card-real-estate.component.html',
  styleUrls: ['./card-real-estate.component.css'],
})
export class CardRealEstateComponent implements OnInit {
  @Input() info: any | undefined;
  @Input() pushLeft: boolean = false;
  @Input() userInversor: any | undefined;
  @Input() userWallets: any;
  @Input() loadingButtons: boolean = true;
  @ViewChild('modalContent') modalContent: TemplateRef<any> | undefined;

  logged: boolean = false;
  nowTimeStamp: number = Math.floor(Date.now() / 1000);
  eurosSold: number = 0;
  acreditado: any;
  percentageSold: string = '0.00';
  percentageSoldNumber: number = 0;
  percentageToPrivateSale: number = 0;

  constructor(
    private authSrv: AuthService,
    private kycSrv: KycService,
    private afs: AngularFirestore,
    private crf: ChangeDetectorRef,
    private modalKycSrv: ModalKycSrv,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.authSrv.loggedIn.subscribe((res: boolean) => {
      this.logged = res;
    });
  }

  async ngOnInit() {    //console.log('Info del proyecto:', this.info);
    this.eurosSold =
      ((this.info?.reserves ?? 0) + this.info.amountSold) *
      (this.info.priceToken / 100);
    this.calculatePercentageSold();
    this.percentageToPrivateSale = this.info.percentageToPrivateSale ?? 0;

    setInterval(() => {
      this.nowTimeStamp = Math.floor(Date.now() / 1000);
      this.crf.detectChanges();
    }, 3000);
  }

  // NUEVO MÉTODO
  canInvest(): boolean {
    // Solo validaciones básicas de UI
    if (!this.logged || this.loadingButtons || !this.info) {
      return false;
    }
    return true;
  }

  calculatePercentageSold() {
    if (this.info.amountToSell && this.info.priceToken) {
      const result =
        (this.eurosSold * 100) /
        (this.info.amountToSell * (this.info.priceToken / 100));
      this.percentageSoldNumber = result;
      this.percentageSold = result.toFixed(2);
    }
  }

  transformDecimals(num: number) {
    const numberFormated = new Intl.NumberFormat('de-DE').format(num);
    return numberFormated;
  }

  // Method to check if the state is "Managing Reinvestments" and should display only this status
  isManagingReinvestments(): boolean {
    const managing = this.info?.managingReinvestments ?? this.info?.managingInvestments;
    return (
      this.info?.proyectStatus === ProjectStatus.ACTIVE &&
      managing &&
      !(this.eurosSold >= this.info.amountToSell * (this.info.priceToken / 100))
    );
  }

  getUrlMainImage() {
    return `url('${this.info.mainImage}')`;
  }

  toFloor(num: number) {
    if (num === undefined || num === null || num === 0) {
      return 'No activo';
    }

    const secondsDiff = num - this.nowTimeStamp;
    const minutesDiff = secondsDiff / 60;
    const hoursDiff = minutesDiff / 60;
    const daysDiff = hoursDiff / 24;

    if (daysDiff >= 1) {
      return 'Quedan: ' + Math.floor(daysDiff) + ' días';
    }

    if (hoursDiff >= 1) {
      return 'Quedan: ' + Math.floor(hoursDiff) + ' horas';
    }

    if (minutesDiff >= 1) {
      return 'Quedan: ' + Math.floor(minutesDiff) + ' minutos';
    }

    if (secondsDiff >= 1) {
      return 'Quedan: ' + Math.floor(secondsDiff) + ' segundos';
    }

    return 'Tiempo agotado';
  }

  convertToAmount(number: any, factor: any) {
    return number * factor;
  }

  kycNoCompleted() {
    Swal.fire(
      'Error',
      'Debes completar la verificacion de tu cuenta para realizar esta operación.',
      'error'
    );
    this.router.navigate(['/perfil']);
    this.modalKycSrv.openModalKyc();
  }

  openFullScreenModal() {
    const dialogRef = this.dialog.open(DetailRealEstateComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'custom-full-screen-modal',
      data: {
        info: this.info,
        cantInvest: !this.canInvest(),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  goToInvestment() {
    console.log(this.info);

    // Validaciones de estado con mensajes específicos
    if (this.info.proyectStatus === 'Vendido') {
      Swal.fire(
        'Proyecto vendido',
        'Este proyecto ya se ha vendido y no está disponible para inversión.',
        'info'
      );
      return;
    }

    if (this.info.proyectStatus === 'Repartiendo dividendos') {
      Swal.fire(
        'Repartiendo dividendos',
        'Este proyecto está en fase de reparto de dividendos y no permite nuevas inversiones.',
        'info'
      );
      return;
    }

    if (this.info.proyectStatus !== 'Activo') {
      Swal.fire(
        'Proyecto no activo',
        'El proyecto no está disponible para inversión en este momento.',
        'info'
      );
      return;
    }

    // Verificar blockchain
    if (!this.info?.blockchain) {
      Swal.fire(
        'Blockchain no disponible',
        'Este proyecto no está disponible para inversión en este momento',
        'info'
      );
      return;
    }

    // Verificar participaciones vendidas
    const targetAmount = this.info.amountToSell * (this.info.priceToken / 100);
    if (this.eurosSold >= targetAmount) {
      Swal.fire(
        'Proyecto financiado',
        'Este proyecto ya ha alcanzado su objetivo de financiación',
        'info'
      );
      return;
    }

    // Verificar tiempo de venta
    if (this.toFloor(this.info.endOfSale) === 'Tiempo agotado') {
      Swal.fire(
        'Tiempo agotado',
        'El período de inversión para este proyecto ha finalizado',
        'info'
      );
      return;
    }

    // Verificar gestión de inversiones
    if (this.info?.managingReinvestments ?? this.info?.managingInvestments) {
      Swal.fire(
        ProjectStatus.MANAGING_REINVESTMENTS,
        'Estamos gestionando sus reinversiones. En breve abriremos el proyecto.',
        'info'
      );
      return;
    }

    // Verificar venta privada
    if (this.info?.onlyInversors) {
      if (!this.userInversor) {
        Swal.fire({
          title: 'Venta privada',
          html: `<p>Esta oportunidad se encuentra en venta privada. Para acceder debes cumplir al menos uno de los siguientes requisitos:</p>
          <ul style="text-align: left;"><li>Haber invertido 50.000€ o más con Domoblock.</li>
          <br>
          <li>Haber participado en 5 o más proyectos, con una inversión acumulada mínima de 2.500€.</li></ul>`,
          icon: 'info',
        })
        return;
      }

      if (this.percentageSoldNumber >= this.percentageToPrivateSale) {
        Swal.fire(
          'Venta privada finalizada',
          'La etapa de venta privada ha terminado. Espera la apertura de la venta pública.',
          'info'
        );
        return;
      } else {
        Swal.fire(
          'Venta privada activa',
          'Puedes invertir en venta privada.',
          'success'
        );
        this.router.navigate(['/oportunidad'], {
          queryParams: { id: this.info.id },
        });
        return;
      }
    }

    // verificar si el proyecto tiene un formulario externo
    const externalFormInfo = externalInvestForms.find(
      (form) =>
        form.project === this.info.title ||
        form.project === this.info.nameTokens ||
        form.project === this.info.symbolTokens
    );
    if(externalFormInfo) {
      window.open(externalFormInfo.url, '_blank');
      return;
    }

    // Navegación final
    this.router.navigate(['/oportunidad'], {
      queryParams: { id: this.info.id },
    });
  }
}
